import React from 'react';
import { LoginCallback } from '@okta/okta-react';
import { Container, Heading, Box, Text } from '@chakra-ui/react';
import { Translation } from 'react-i18next';

const CustomLoginCallback = () => {

    const renderError = (props) => {
        const { error } = props;

        if (error) {
            const { name, errorCode, errorSummary } = error;

             if (errorCode === 'access_denied' && errorSummary === 'The resource owner or authorization server denied the request.') {  //customized error handling
                 return (
                     <Translation>
                         {(t) => (
                             <Container maxW="700px" mt="7em">
                                 <Heading as="h1" fontSize="3xl" fontWeight="bold" mb={4}>{t('Access Denied')}</Heading>
                                 <Box p={6} borderWidth="1px" borderRadius="lg" bg="white" shadow="sm">
                                     <Text fontSize="lg" mb={2}>{t('no_active_session')}</Text>
                                     <Text>{t('Please contact the Nike Service Desk for support')}</Text>
                                 </Box>
                             </Container>
                         )}
                     </Translation>
                 );
             }

             //generic error handling
             return (
                 <Translation>
                     {(t) => (
                         <Container maxW="700px" mt="7em">
                             <Heading as="h1" fontSize="3xl" fontWeight="bold" mb={4}>{t('error')}</Heading>
                             <Box p={6} borderWidth="1px" borderRadius="lg" bg="white" shadow="sm">
                                 <Heading as="h3" fontSize="xl" fontWeight="semibold" mb={2}>{t(errorSummary)}</Heading>
                                 <Text>{t('Please contact the Nike Service Desk for support')}</Text>
                             </Box>
                         </Container>
                     )}
                 </Translation>
             );
         }

        return null;
    };
     return <LoginCallback errorComponent={renderError} />;
};

export default CustomLoginCallback;